import { render, staticRenderFns } from "./KirinyagaPermitDetails.vue?vue&type=template&id=3a1c76a0"
import script from "./KirinyagaPermitDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./KirinyagaPermitDetails.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports